export default __webpack_public_path__ + "static/cloud7x24-78e1926b49e8d60f187ab57d5d3230c5.png";